module.exports = __webpack_public_path__ + "img/zoom.83feb708.svg";